/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import moment from 'moment';
import { FormattedMessage, injectIntl } from '../../util/reactIntl.js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import config from '../../config.js';
import routeConfiguration from '../../routeConfiguration.js';
import { findOptionsForSelectFilter } from '../../util/search.js';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types.js';
import { daysBetween } from '../../util/dates.js';
import { types as sdkTypes } from '../../util/sdkLoader.js';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers.js';
import { formatMoney } from '../../util/currency.js';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes.js';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data.js';
import { richText } from '../../util/richText.js';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck.js';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck.js';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  IconChevronRight,
  CartModal
} from '../../components/index.js';
import { TopbarContainer, NotFoundPage } from '../index.js';

import { sendEnquiry, loadData, setInitialValues, getComplementaryProducts } from './SubscriptionListingPage.duck.js';
import SectionImages from './SectionImages.js';
import SectionHeading from './SectionHeading.js';
import SectionDescriptionMaybe from './SectionDescriptionMaybe.js';
import SectionVariantsMaybe from './SectionVariantsMaybe.js';
import SectionReviews from './SectionReviews.js';
import SectionHostMaybe from './SectionHostMaybe.js';
import SectionRulesMaybe from './SectionRulesMaybe.js';
import SectionMapMaybe from './SectionMapMaybe.js';
import css from './ListingPage.css';

import checkoutEvent from './checkoutEvent.js';
import viewProductEvent from './viewProductEvent.js';
import { viewItemEvent } from './viewItemEvent.js';
import BookingPanel from './BookingPanel';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

const categoryLabel = (categories, key) => {
  const cat = categories.find(c => c.key === key);
  return cat ? cat.label : key;
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      isCartModalOpen: false,
      isSizesModalOpen: false,
      productCategory: null
    };
  }

  componentDidMount() {
    // only works server side as GA tracking
    const {
      params, getListing, getOwnListing, onFetchVariants
    } = this.props;

    const listingId = new UUID(params.id);
    const isPendingApprovalVariant = params.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = params.variant === LISTING_PAGE_DRAFT_VARIANT;
    const listing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    listing.id && viewItemEvent({
      currency: listing.attributes.price.currency,
      value: listing.attributes.price.amount / 100,
      item: {
        price: listing.attributes.price.amount / 100,
        id: listing.id.uuid,
        name: listing.attributes.title,
        category: listing.attributes.businessCategory,
        provider: listing.provider?.attributes.name,
        // TO-DO Remember when adding quantity field
        quantity: 1
      }
    });

    listing.id && viewProductEvent({
      name: listing.attributes.title,
      productId: listing.id.uuid,
      price: listing.attributes.price.amount / 100,
      category: listing.attributes ? listing.attributes.category : '',
      brand: listing.provider?.attributes.name,
    })
  }

  render() {
    const {
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      history,
      intl,
      onManageDisableScrolling,
      params: rawParams,
      scrollingDisabled,
      showListingError,
      reviews,
      filterConfig,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;
    const listingTab = isDraftVariant ? 'photos' : 'description';


    const {
      description = '',
      price = null,
      title = '',
      externalLink,
      category
    } = currentListing.attributes;

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const topbar = <TopbarContainer />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };
    const authorAvailable = currentListing && currentListing.provider;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing = currentListing.provider?.attributes.myRole ||
      (userAndListingAuthorAvailable && currentListing.provider.id.uuid === currentUser.id.uuid);

    const currentAuthor = authorAvailable ? currentListing.provider : null;
    const ensuredAuthor = ensureUser(currentAuthor);
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing)) && ensuredAuthor.attributes && !!ensuredAuthor.attributes.isDecathlon;

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, ensuredAuthor.attributes.name);

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'scaled-small');
    const twitterImages = listingImages(currentListing, 'scaled-small');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );

    const handleBack = () => {
      if (history.length > 2) {
        history.goBack();
      } else {
        history.push(`/s?address=Polska&bounds=55.98904748%2C24.05383751%2C47.89042442%2C14.14416954&pub_category=${currentListing.attributes.category}`)
      }
    }

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const categoryOptions = findOptionsForSelectFilter('category', filterConfig);
    const categoryDisplay =
      category ? (
        <span>
          {categoryLabel(categoryOptions, category)}
          <span className={css.separator}>•</span>
        </span>
      ) : null;

    const rating = reviews.map(x => x.attributes.rating).reduce((previous, current) => current += previous, 0) / reviews.length;

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={`${intl.formatMessage({ id: "ListingPage.rentAt" })} ${authorDisplayName} ${description}`}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'Product',
          productId: listingId.uuid,
          description: `${intl.formatMessage({ id: "ListingPage.rentAt" })} ${authorDisplayName} ${description}`,
          name: schemaTitle,
          image: schemaImages,
          brand: authorDisplayName,
          google_product_category: '988',
          offers: [{
            '@type': 'Offer',
            price: price.amount / 100,
            priceCurrency: 'PLN',
            availability: "https://schema.org/InStock"
          }]
        }}
      >
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div>
              <div className={css.topButtonsContainer}>
                <button className={css.backButton} onClick={handleBack}>
                  <IconChevronRight className={css.chevronLeft} />
                  <FormattedMessage id="ListingPage.backButton" />
                </button>
              </div>
              <div className={css.content}>
                <div className={css.contentWraper}>
                  <div className={css.sectionWithBackground}>
                    <div className={css.contentContainer}>
                      <SectionHeading
                        priceTitle={priceTitle}
                        formattedPrice={formattedPrice}
                        richTitle={richTitle}
                        category={categoryDisplay}
                        hostLink={hostLink}
                        showContactUser={showContactUser}
                        onContactUser={this.onContactUser}
                        rating={rating}
                        reviewsCount={reviews.length}
                        listing={currentListing}
                        isOwnListing={isOwnListing}
                        editParams={{
                          id: listingId.uuid,
                          slug: listingSlug,
                          type: listingType,
                          tab: listingTab,
                        }}
                      />
                      <SectionImages
                        title={title}
                        listing={currentListing}
                        isOwnListing={isOwnListing}
                        editParams={{
                          id: listingId.uuid,
                          slug: listingSlug,
                          type: listingType,
                          tab: listingTab,
                        }}
                        imageCarouselOpen={this.state.imageCarouselOpen}
                        onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                        handleViewPhotosClick={handleViewPhotosClick}
                        onManageDisableScrolling={onManageDisableScrolling}
                        intl={intl}
                      />
                    </div>
                  </div>
                  <div className={css.contentContainer}>
                    {/* <SectionVariantsMaybe
                      listingId={listingId.uuid}
                      providerId={currentListing.provider?.id.uuid}
                      providerName={currentListing.provider?.attributes.name}
                      point={currentListing.provider?.attributes.location ? `${currentListing.provider?.attributes.location.lat},${currentListing.provider?.attributes.location.lng}` : null}
                      onOpenSizesModal={() => this.setState({ isSizesModalOpen: true })}
                      productCategory={currentListing.attributes.businessCategory}
                    /> */}
                    <SectionDescriptionMaybe
                      description={description}
                      externalLink={externalLink}
                      isDecathlon={ensuredAuthor.attributes.isDecathlon}
                    />
                    <SectionRulesMaybe
                      authorPublicData={ensuredAuthor.attributes}
                      listingPublicData={currentListing.attributes}
                      isDecathlon={ensuredAuthor.attributes.isDecathlon}
                      intl={intl}
                    />
                    <SectionMapMaybe
                      geolocation={currentListing.attributes.locations ? currentListing.attributes.locations[0] : null}
                      publicData={{}}
                      listingId={currentListing.id}
                      listingPublicData={{}}
                      listing={currentListing}
                    />
                    {/* <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} rating={rating} /> */}
                    {/* <SectionHostMaybe
                      title={title}
                      listing={currentListing}
                      authorDisplayName={authorDisplayName}
                      showContactUser={showContactUser}
                      onContactUser={this.onContactUser}
                      isEnquiryModalOpen={isAuthenticated && this.state.enquiryModalOpen}
                      onCloseEnquiryModal={() => this.setState({ enquiryModalOpen: false })}
                      sendEnquiryError={sendEnquiryError}
                      sendEnquiryInProgress={sendEnquiryInProgress}
                      onSubmitEnquiry={this.onSubmitEnquiry}
                      currentUser={currentUser}
                      onManageDisableScrolling={onManageDisableScrolling}
                    /> */}
                  </div>
                </div>
                <div className={css.bookingColumn}>
                  <BookingPanel
                    currentListing={currentListing}
                  />
                </div>
              </div>
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter className={css.footer}>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  sendEnquiryError: null,
  filterConfig: config.custom.filters,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  // Topbar needs user info.
  const { isPromoOn, promoCode, discount, discountedCategories } = state.Promo;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    enquiryModalOpenForListingId,
    complementaryListing,
    fetchListingInProgress
  } = state.ListingPage;
  const { currentUser } = state.user;

  const { addToCartInProgress, addToCartError, addToCartSuccess, cart } = state.CartPage;

  const getListing = id => {
    const ref = { id, type: 'subscription-listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    promo: { isPromoOn, promoCode, discount, discountedCategories },
    complementaryProducts: getMarketplaceEntities(state, complementaryListing),
    addToCartInProgress,
    addToCartSuccess,
    cartListing: getMarketplaceEntities(state, cart),
    fetchListingInProgress
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
  onSendEnquiry: (listingId, message) => dispatch(sendEnquiry(listingId, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  getComplementaryProducts: data => dispatch(getComplementaryProducts(data))
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageComponent);

ListingPage.setInitialValues = initialValues => setInitialValues(initialValues);
ListingPage.loadData = loadData;

export default ListingPage;
